<template>
    <ToolButton :Editor="Editor" KnownIcon="Publish" @ToolClick="Clicked()" :Size="10">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    methods: {
        Clicked() {
            this.$emit('Publish');
        }
    },
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>